import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './Components/Header';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import Home from './Components/Home';
import Technology from './Components/Technology';
import Utilities from './Components/Utilities';
import Infrastructure from './Components/Infrastructure';
import Energy from './Components/Energy';
import Industry from './Components/Industry';
import MachineENG from './Components/MachineENG';
import SoftWareENG from './Components/Analysevibratoireservice';
import Transport from './Components/Transport';
import Industrial from './Components/Industrial';
import Maintenance from './Components/Maintenance';
import Pétrole from './Components/Pétrole';
import Automatisation from './Components/Automatisation';
import Solution from './Components/Solution';
import AnalyseVibratoire from './Components/AnalyseVibratoire';
import Gestionbatiment from './Components/Gestionbatiment';
import Gestionlubrification from './Components/Gestionlubrification';
import Industryauto from './Components/Industryauto';
import Monitoring from './Components/Monitoring';
import Software from './Components/Software';
import Services from './Components/Services';
import Analysevibratoireservice from './Components/Analysevibratoireservice';
import Traitement from './Components/Traitement';
import Aboutus from './Components/Aboutus';
import ScrollToTop from './Components/ScrollToTop';
// import DeveloppementLogiciel from './Components/DeveloppementLogiciel';
// import Cybersecurite from './Components/Cybersecurite';
// import AnalyseDonnees from './Components/AnalyseDonnees';
// import GestionBDD from './Components/GestionBDD';
// import SolutionsReseaux from './Components/SolutionsReseaux';

const App = () => {
  return (
    <div className="app-container">
      <Router>
        <ScrollToTop />
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
             <Route path="/aboutus" element={<Aboutus />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/Formation" element={<Traitement />} />
            <Route path="/services" element={<Services />} />
            <Route path="/solutions" element={<Solution />} />
            <Route path="/team" element={<div><h1>Team Page</h1></div>} />
            <Route path="/projects" element={<div><h1>Project Page</h1></div>} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/Utilities" element={<Utilities />} />
            <Route path="/Infrastructure" element={<Infrastructure />} />
            <Route path="/energy" element={<Energy />} />
            <Route path="/Industry" element={<Industry />} />
            <Route path="/Routes&transports" element={<Transport />} />
            <Route path="/Pétrole" element={<Pétrole />} />
            <Route path="/Maintenance" element={<Maintenance />} />
            <Route path="/Analysevibratoire" element={<Analysevibratoireservice />} />
            <Route path="/machine-engineering" element={<MachineENG />} />
            <Route path="/Automatisation" element={<Automatisation />} />
            <Route path="/industrial-engineering" element={<Industrial />} />
            <Route path="/solutions/analyse-vibratoire" element={<AnalyseVibratoire />} />
            <Route path="/solutions/gestion" element={<Gestionbatiment />} />
            <Route path="/solutions/gestion-lubrification" element={<Gestionlubrification />} />
            <Route path="/solutions/Industry&auto" element={<Industryauto />} />
            <Route path="/solutions/Monitoring" element={<Monitoring />} />
            <Route path="/solutions/software" element={<Software />} /> 
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
};

export default App;